import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { getFont, FONT, FONT_TYPE } from '@tornado-rdk/typography';
import { CLOUD_NORMAL, TERTIARY, PRIMARY, makeThemeColor } from '@tornado-rdk/theme';
import { cacheResolver, makeDefaultStylingContext } from '../../tornado/utils/style';

export const defaultContext = makeDefaultStylingContext();

export const ITEM_WIDTH = {
  [HD]: 296,
  [FULL_HD]: 442,
};

export const ITEM_HEIGHT = {
  [HD]: 40,
  [FULL_HD]: 56,
};

export const ITEM_MARGIN_BOTTOM = {
  [HD]: 4,
  [FULL_HD]: 1,
};

export const ICON_MARGIN_TOP = {
  [HD]: 8,
  [FULL_HD]: 16,
};

export const ICON_MARGIN_BOTTOM = {
  [HD]: 8,
  [FULL_HD]: 16,
};

export const ICON_MARGIN_LEFT = {
  [HD]: 8,
  [FULL_HD]: 16,
};

export const ICON_MARGIN_RIGHT = {
  [HD]: 24,
  [FULL_HD]: 24,
};

export const ICON_DIMENSION = {
  [HD]: {
    w: 24,
    h: 24,
  },
  [FULL_HD]: {
    w: 24,
    h: 24,
  },
};

export const colors = {
  background: makeThemeColor(CLOUD_NORMAL)[defaultContext.colorMode],
};

export const TITLE_FONT = FONT.BERLIN_1;

export const TITLE_FONT_TYPE = FONT_TYPE.MAIN;

export const BACKGROUND_FOCUSED_COLOR = makeThemeColor(PRIMARY);

export const BACKGROUND_UNFOCUSED_COLOR = makeThemeColor(TERTIARY);

export const TEXT_UNFOCUSED_COLOR = makeThemeColor(PRIMARY);

export const TEXT_FOCUSED_COLOR = makeThemeColor(TERTIARY);

export const HISTORY_ICON = { name: 'History', type: 'icon' };

export const getUnFocusedStyle = ({ colorMode }) => ({
  color: BACKGROUND_UNFOCUSED_COLOR[colorMode],
  Icon: {
    color: TEXT_UNFOCUSED_COLOR[colorMode],
  },
  Title: {
    color: TEXT_UNFOCUSED_COLOR[colorMode],
  },
});

export const getFocusedStyle = ({ colorMode }) => ({
  color: BACKGROUND_FOCUSED_COLOR[colorMode],
  Icon: {
    color: TEXT_FOCUSED_COLOR[colorMode],
  },
  Title: {
    color: TEXT_FOCUSED_COLOR[colorMode],
  },
});

export const getInitialStyle = ({ screenSize, colorMode } = defaultContext) => ({
  rect: true,
  color: BACKGROUND_UNFOCUSED_COLOR[colorMode],
  w: ITEM_WIDTH[screenSize],
  h: ITEM_HEIGHT[screenSize],
  flex: {
    direction: 'row',
    alignItems: 'center',
  },
  flexItem: {
    marginBottom: ITEM_MARGIN_BOTTOM[screenSize],
  },
  Icon: {
    flexItem: {
      marginTop: ICON_MARGIN_TOP[screenSize],
      marginBottom: ICON_MARGIN_BOTTOM[screenSize],
      marginLeft: ICON_MARGIN_LEFT[screenSize],
      marginRight: ICON_MARGIN_RIGHT[screenSize],
    },
  },
  Title: {
    text: {
      ...getFont(TITLE_FONT, screenSize, TITLE_FONT_TYPE),
      maxLines: 1,
      verticalAlign: 'middle',
      textAlign: 'center',
      maxLinesSuffix: '...',
      wrap: true,
      wordWrapWidth:
        ITEM_WIDTH[screenSize] -
        ICON_MARGIN_LEFT[screenSize] -
        ICON_DIMENSION[screenSize].w -
        ICON_MARGIN_RIGHT[screenSize],
    },
  },
  cacheResolver,
});
